import { DashboardDefinition } from '@/app/pages/dashboard/models/dashboard.models';

export const EXECUTIVE_DASHBOARD: DashboardDefinition = {
  key: 'executive',
  title: 'Executive Dashboard',
  subtitle:
    'Portfolio-wide visibility into shipment performance, spend, and service trends.',
  theme: 'executive',
  asmOnly: true,
  defaultWidgetIds: [
    'totalDisplay',
    'expeditedSuppliersChart',
    'shipmentStatusChart',
    'shipmentPickupChart',
    'shipmentPickupServiceTypeChart',
    'shipmentDeliveryChart',
    'shipmentDeliveryServiceTypeChart',
    'serviceTypeChart',
    'spendByMonth',
    'loadHistory',
  ],
};
